import styled from 'styled-components';

/** Centered copy + media blocks for detail page bodies (e.g. ParkBean). */
export const DetailContent = styled.div`
  .section {
    text-align: center;
    margin: var(--marginhalf) auto 0;
    max-width: 90vw;
    line-height: 1.65;
    @media (min-width: 1023px) {
      max-width: 70vw;
    }
  }

  .sectiontitle {
    font-size: var(--fontsizetitlec);
    font-weight: 500;
    margin: var(--marginhalf) 0 3vh;
    @media (min-width: 1023px) {
      font-size: var(--fontsizetitleb);
      margin-bottom: 4vh;
    }
  }

  .screenshots {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--marginhalf);
    margin-top: 3vh;
    @media (min-width: 1023px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .screenshotcard {
    text-align: center;
  }

  .screenshotcard img {
    width: 100%;
    max-width: 160px;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    margin: 0 auto 3.5vh;
    display: block;
    @media (min-width: 1023px) {
      max-width: 100%;
      border-radius: var(--radius-lg);
      margin-bottom: 4vh;
    }
  }

  .screenshotcaption {
    font-weight: 500;
    margin-bottom: 1.5vh;
  }

  .screenshotdesc {
    font-size: var(--fontsizecontentc);
    line-height: 1.5;
    padding: 0 0.5em;
    @media (min-width: 1023px) {
      font-size: var(--fontsizecontentb);
    }
  }

  .meta {
    margin-top: var(--marginhalf);
  }
`;
